import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "account_balance", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal_button = _resolveComponent("base-modal-button")!
  const _component_base_tab_link = _resolveComponent("base-tab-link")!
  const _component_CpAbstractsOverview = _resolveComponent("CpAbstractsOverview")!
  const _component_base_tab_pane = _resolveComponent("base-tab-pane")!
  const _component_base_tab = _resolveComponent("base-tab")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_modal_button, {
      class: "btn btn-hover icon-link",
      "modal-id": this.modalId
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createTextVNode(_toDisplayString(_ctx.$t('copyFromLibrary')), 1)
      ]),
      _: 1
    }, 8, ["modal-id"]),
    _createVNode(_component_base_modal, {
      "modal-id": this.modalId,
      "dialog-classes": "modal-xl modal-dialog-scrollable",
      title: this.title ?? 'Content pages library'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_base_tab, { "tab-id": "nav-tab" }, {
          tabs: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.contentBlockLibsForType, (contentBlockLibForType, i) => {
              return (_openBlock(), _createBlock(_component_base_tab_link, {
                key: contentBlockLibForType.library.code,
                target: contentBlockLibForType.library.code,
                title: contentBlockLibForType.library.description,
                "is-active": i === 0
              }, null, 8, ["target", "title", "is-active"]))
            }), 128))
          ]),
          content: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.contentBlockLibsForType, (contentBlockLibForType, i) => {
              return (_openBlock(), _createBlock(_component_base_tab_pane, {
                key: contentBlockLibForType.library.code,
                id: contentBlockLibForType.library.code,
                "is-active": i === 0,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CpAbstractsOverview, {
                    "lib-code": contentBlockLibForType.library.code,
                    onExceptions: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('exceptions'))),
                    onSelectedCp: this.onCopy
                  }, null, 8, ["lib-code", "onSelectedCp"])
                ]),
                _: 2
              }, 1032, ["id", "is-active"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modal-id", "title"])
  ], 64))
}